import { render, staticRenderFns } from "./DeactivateSyncDialog.vue?vue&type=template&id=1068dda5&"
import script from "./DeactivateSyncDialog.vue?vue&type=script&lang=js&"
export * from "./DeactivateSyncDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports